import { render } from "./TrainingBlocPauseSubscriptionButton.vue?vue&type=template&id=0a463be2"
import script from "./TrainingBlocPauseSubscriptionButton.vue?vue&type=script&lang=js"
export * from "./TrainingBlocPauseSubscriptionButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__